import React, { useState, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import subjecte from "./subjecte.png";
import { useNavigate } from "react-router-dom";

const Subjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);

  const navigate = useNavigate();

  /* ================= FETCH (DATA UNCHANGED) ================= */
  useEffect(() => {
    const fetchSubjects = async () => {
      setLoading(true);
      setError(false);
      try {
        const response = await fetch(
          "https://wsms.aidigitalsec.com/api/TeacherDashboard/Dashboard_SubjectCard",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: sessionStorage.getItem("token"),
            },
          }
        );

        const data = await response.json();
        const subjectList = Array.isArray(data.list) ? data.list : [];

        const subjectsMap = {};
        subjectList.forEach((item) => {
          if (!subjectsMap[item.subjectName]) {
            subjectsMap[item.subjectName] = {
              subjectName: item.subjectName,
              classes: [],
            };
          }

          const classIndex =
            subjectsMap[item.subjectName].classes.findIndex(
              (cls) => cls.className === item.className
            );

          if (classIndex === -1) {
            subjectsMap[item.subjectName].classes.push({
              className: item.className,
              sections: [item.secrionName],
            });
          } else {
            subjectsMap[item.subjectName].classes[classIndex].sections.push(
              item.secrionName
            );
          }
        });

        setSubjects(Object.values(subjectsMap));
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchSubjects();
  }, []);

  /* ================= SUBJECT CARD (WITH LOADING INSIDE) ================= */
  return (
    <>
      <Box
        sx={{
          width: 270,
          height: 185,
          borderRadius: "22px",
          background:
  "linear-gradient(145deg, rgba(245,158,11,0.95), rgba(217,119,6,0.95))",

          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0 22px 55px rgba(245,158,11,0.45)",

          cursor: loading ? "default" : "pointer",
          transition: "all .35s ease",
          "&:hover": loading
            ? {}
            : {
                transform: "translateY(-6px)",
                boxShadow:
                  "0 32px 75px rgba(245,158,11,0.65)",
              },
        }}
        onClick={() => {
          if (!loading && !error) setOpenPopup(true);
        }}
      >
        {/* ===== LOADING STATE (CARD LEVEL) ===== */}
        {loading && (
          <>
            <CircularProgress sx={{ color: "#fff", mb: 1.5 }} />
            <Typography fontWeight={800} fontSize={14}>
              Loading Subjects...
            </Typography>
          </>
        )}

        {/* ===== ERROR STATE ===== */}
        {error && !loading && (
          <Typography color="#fecaca" fontWeight={800}>
            Failed to load
          </Typography>
        )}

        {/* ===== NORMAL STATE ===== */}
        {!loading && !error && (
          <>
            <img src={subjecte} alt="subject" width={48} />
            <Typography fontWeight={900} fontSize={20} mt={1}>
              Subjects
            </Typography>
            <Typography fontSize={12} sx={{ opacity: 0.85 }}>
              Click to view details
            </Typography>
          </>
        )}
      </Box>

      {/* ================= POPUP ================= */}
      <Dialog
        open={openPopup}
        onClose={() => setOpenPopup(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "22px",
            overflow: "hidden",
          },
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            p: 3,
            color: "#fff",
          background:
  "linear-gradient(145deg, rgba(245,158,11,0.95), rgba(217,119,6,0.95))",

            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <SchoolIcon />
          <Typography fontWeight={900} fontSize={20}>
            Subjects
          </Typography>
        </Box>

        {/* CONTENT (FULL DATA) */}
        <DialogContent
  sx={{
    background: "linear-gradient(145deg,#ffffff,#f8fafc)", // ✅ Classes back same
    p: 3,
    maxHeight: "55vh",
  }}
>

          {subjects.map((subject) => (
   
<Box
  key={subject.subjectName}
  sx={{
    mb: 2.5,
    p: 2,
    borderRadius: "16px",

    background:
      "linear-gradient(145deg, rgba(245,158,11,0.95), rgba(217,119,6,0.95))",

    color: "#ffffff",

    boxShadow: "0 10px 25px rgba(245,158,11,0.35)",
  }}
>


              <Typography
                fontWeight={900}
                fontSize={16}
                mb={1}
              >
                {subject.subjectName}
              </Typography>

              {subject.classes.map((cls) => (
                <Typography
                  key={cls.className}
                  fontSize={14}
                  sx={{ ml: 1, opacity: 0.95 }}
                >
                  {cls.className}: Sections:{" "}
                  {cls.sections.join(", ")}
                </Typography>
              ))}
            </Box>
          ))}
        </DialogContent>

        {/* FOOTER */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
           background: "linear-gradient(135deg,#92400e,#78350f)",

          }}
        >
          <Button
            onClick={() => navigate("/subject-detail")}
           sx={{
  background:
    "linear-gradient(145deg, rgba(245,158,11,0.95), rgba(217,119,6,0.95))",
  color: "#fff",
  fontWeight: 900,
  borderRadius: "14px",
  px: 3,
  boxShadow: "0 6px 16px rgba(245,158,11,0.45)",
  "&:hover": {
    background:
      "linear-gradient(145deg, rgba(217,119,6,1), rgba(180,83,9,1))",
  },
}}

          >
            More Info
          </Button>

          <Button
            onClick={() => setOpenPopup(false)}
           sx={{
  background:
    "linear-gradient(145deg, rgba(120,53,15,1), rgba(146,64,14,1))",
  color: "#fff",
  fontWeight: 900,
  borderRadius: "14px",
  px: 4,
  boxShadow: "0 6px 16px rgba(120,53,15,0.5)",
  "&:hover": {
    background:
      "linear-gradient(145deg, rgba(146,64,14,1), rgba(120,53,15,1))",
  },
}}

          >
            Close
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default Subjects;
